import DeleteIcon from 'assets/settings/components/DeleteIcon';
import EditIcon from 'assets/settings/components/EditIcon';

import {
  ActionButton,
  ActionsSection,
  Badge,
  BadgesWrapper,
  Card,
  ContentSection,
  Description,
  HeaderSection,
  StatusBadge,
  StatusBadgesWrapper,
  StatusColumn,
  StatusInfo,
  StatusLabel,
  Title,
} from './UserPrivilegeCard.styles';

const UserPrivilegeCard = ({
  name,
  description,
  viewableStatuses,
  changeableStatuses,
  enabled,
  onEdit,
  onDelete,
}) => {
  return (
    <Card>
      <ContentSection>
        <HeaderSection>
          <Title title={name}>{name}</Title>
          <BadgesWrapper>
            <Badge $type={enabled ? 'status-enabled' : 'status-disabled'}>
              {enabled ? 'Enabled' : 'Disabled'}
            </Badge>
          </BadgesWrapper>
        </HeaderSection>

        {description && <Description title={description}>{description}</Description>}

        <StatusInfo>
          <StatusColumn>
            <StatusLabel>Viewable Statuses:</StatusLabel>
            <StatusBadgesWrapper>
              {viewableStatuses && viewableStatuses.length > 0 ? (
                viewableStatuses.map((status) => (
                  <StatusBadge key={status.id}>{status.name}</StatusBadge>
                ))
              ) : (
                <StatusBadge>Not Set</StatusBadge>
              )}
            </StatusBadgesWrapper>
          </StatusColumn>

          <StatusColumn>
            <StatusLabel>Changeable Statuses:</StatusLabel>
            <StatusBadgesWrapper>
              {changeableStatuses && changeableStatuses.length > 0 ? (
                changeableStatuses.map((status) => (
                  <StatusBadge key={status.id} $changeable>
                    {status.name}
                  </StatusBadge>
                ))
              ) : (
                <StatusBadge $changeable>Not Set</StatusBadge>
              )}
            </StatusBadgesWrapper>
          </StatusColumn>
        </StatusInfo>
      </ContentSection>

      <ActionsSection>
        <ActionButton onClick={onEdit}>
          <EditIcon size={16} color="#2D6CDF" />
        </ActionButton>
        <ActionButton onClick={onDelete} $delete>
          <DeleteIcon size={16} color="#FB2C36" />
        </ActionButton>
      </ActionsSection>
    </Card>
  );
};

export default UserPrivilegeCard;
